export default __webpack_public_path__ + "static/media/image82.5b6139b9.webp";